






























































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';

import GenealogyPersonPreview from '@/components/genealogy/GenealogyPersonPreview.vue';
import WikitreeController from '@/controllers/WikitreeGenealogyController';
import { GenealogyPersonSearchRequest, GenealogyPerson } from '@/models/Genealogy';

@Component({
    components:
    {
        GenealogyPersonPreview
    }
})
export default class GenealogyPersonSearchInput extends Vue
{
    @Prop({ default: false, type: Boolean }) readonly disabled!: boolean;

    loading = false;
    searched = false;
    request : GenealogyPersonSearchRequest = new GenealogyPersonSearchRequest();
    results : GenealogyPerson[] = [];

    get shouldDisableFields()
    {
        return this.loading || this.disabled;
    }

    get invalidInput()
    {
        return this.request.first_name === '' && this.request.last_name === '';
    }

    async search(ev : Event)
    {
        ev.preventDefault();
        this.loading = true;

        try
        {
            const r : GenealogyPerson[] | null = ((await WikitreeController.SearchForPerson(this.request.toRequestObject())) as GenealogyPerson[]);
            this.searched = true;
            this.results = (r != null) ? r.map(el => new GenealogyPerson(el)) : []; // TODO: why?
            this.results = this.results.filter(el => el.birth_date != null);

            // make sure results list is starts scrolled to top
            await Vue.nextTick();
            const el = document.getElementById('genealogyImporterModal');
            if (el != null)
            {
                el.scrollTo(0, 0);
            }
        }
        catch (err)
        {
            const resp = err.response;
            this.searched = true;
            this.loading = false;
            return resp.data;
        }

        this.loading = false;
        return true;
    }
}
